export enum DefaultRoutes {
  // Rutas por defecto según rol
  ADMIN_DASHBOARD = '/app/dashboard',
  SUPER_ADMIN_DASHBOARD = '/app/dashboard-admin',
  MACRO_COMMUNITY_HOME = '/app-community/reservations',
  // Rutas para rol customized en macro-community
  CUSTOMIZED_MACRO_ACCESS_CONTROL = '/app-community/door-opening-macro-admin/access',
  CUSTOMIZED_MACRO_SECURITY_CENTER = '/app-community/door-opening-macro-admin/security',
  
  COMMITTEE_DASHBOARD = '/app/committee-dashboard',
  // Rutas para rol customized en edificios tradicionales
  CUSTOMIZED_BUSINESS_ACCESS_CONTROL = '/app/door-opening-business/access',
  CUSTOMIZED_BUSINESS_SECURITY_CENTER = '/app/door-opening-business/security',
  CUSTOMIZED_TRADITIONAL_DOOR_OPENING = '/app/door-opening',
  
  // Rutas de autenticación
  LOGIN = '/auth/login'
}

//Mapeo de features a rutas para rol customized
export const CUSTOMIZED_ROUTE_MAPPING = {
  // Macro-community features
  accessControlMacroAdmin: DefaultRoutes.CUSTOMIZED_MACRO_ACCESS_CONTROL,
  securityCenterMacroAdmin: DefaultRoutes.CUSTOMIZED_MACRO_SECURITY_CENTER,
  
  // Business features
  accessControlMacroBusiness: DefaultRoutes.CUSTOMIZED_BUSINESS_ACCESS_CONTROL,
  securityCenterMacroBusiness: DefaultRoutes.CUSTOMIZED_BUSINESS_SECURITY_CENTER
} as const;

//Configuración de rutas por rol
export const ROLE_ROUTE_CONFIG = {
  admin: {
    traditional: DefaultRoutes.ADMIN_DASHBOARD,
    macroCommunity: DefaultRoutes.MACRO_COMMUNITY_HOME
  },
  superAdmin: {
    traditional: DefaultRoutes.SUPER_ADMIN_DASHBOARD
  },
  customized: {
    traditional: DefaultRoutes.CUSTOMIZED_TRADITIONAL_DOOR_OPENING,
    macroCommunity: DefaultRoutes.MACRO_COMMUNITY_HOME
  },
  committee: {
    traditional: DefaultRoutes.COMMITTEE_DASHBOARD
  }
} as const;

//Rutas que requieren verificación de acceso relacionado
export const RELATED_ROUTES = {
  MACRO_ADMIN_ROUTES: [
    DefaultRoutes.CUSTOMIZED_MACRO_ACCESS_CONTROL,
    DefaultRoutes.CUSTOMIZED_MACRO_SECURITY_CENTER
  ],
  BUSINESS_ROUTES: [
    DefaultRoutes.CUSTOMIZED_BUSINESS_ACCESS_CONTROL,
    DefaultRoutes.CUSTOMIZED_BUSINESS_SECURITY_CENTER
  ]
} as const;

export const PROVIDER_DIRECTORY_URL = 'https://integraciones.munily.com/';